import { render, staticRenderFns } from "./userInfoModal.vue?vue&type=template&id=f4766a16"
import script from "./userInfoModal.vue?vue&type=script&lang=js"
export * from "./userInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports